import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full h-full flex flex-col py-12px justify-start overflow-auto" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src", "onLoad"]
const _hoisted_4 = { key: 0 }

import { ElInput, ElButton, ElIcon, ElDropdown, ElDropdownMenu, ElDropdownItem, ElMessageBox, ElMessage, ElEmpty } from 'element-plus'
import { Folder, Search, Filter, FolderRemove, FolderOpened, Plus, ArrowLeft } from '@element-plus/icons-vue'
import { ref, computed, onMounted, nextTick, onBeforeUnmount, watch } from 'vue'
import { getResourceList } from '@/api/affairs'
import { useSdkStore } from '@/stores/sdk'


export default /*@__PURE__*/_defineComponent({
  __name: 'myUpload',
  props: {
  id: {
    type: Number,
    default: 0
  }
},
  setup(__props, { expose: __expose }) {

const sdkStore = useSdkStore()

const desginsdk = sdkStore.getSdk()
onMounted(() => {
  getList()

})

const props = __props
watch(() => props.id, (newVal, oldVal) => {
  if (newVal != oldVal) {
    getList()
  }
})

const resourceList = ref([])
const gridRef = ref<HTMLElement | null>(null)
const wideMap = ref<Record<string, boolean>>({})
const isWide = (id: any) => !!wideMap.value[id]
const cols = ref(3)
let ro: ResizeObserver | null = null
let useColsWindowListener = false

const updateCols = () => {
  const el = gridRef.value
  if (!el) return
  const w = el.clientWidth
  cols.value = w >= 900 ? 4 : 3
}

const getList = () => {
  getResourceList({
    pageNum: 1, pageSize: 30, file_type: 2, folder_id: props.id
  }).then(res => {
    resourceList.value = res.data.data.items
  })
}

__expose({ getList })

// 移除基于 grid 行高的测量逻辑，改用 CSS columns 布局

const onImgLoad = (e: Event, item: any) => {
  const img = e.target as HTMLImageElement
  if (img && img.naturalHeight > 0) {
    wideMap.value[item.id] = img.naturalWidth / img.naturalHeight > 2
  }
}

onMounted(() => {
  updateCols()
  if (typeof ResizeObserver !== 'undefined') {
    ro = new ResizeObserver(() => {
      updateCols()
    })
    ro.observe(gridRef.value as HTMLElement)
  } else {
    window.addEventListener('resize', updateCols)
    useColsWindowListener = true
  }
})
onBeforeUnmount(() => {
  if (ro) ro.disconnect()
  if (useColsWindowListener) window.removeEventListener('resize', updateCols)
})


const handleClick = (item: any) => {
  desginsdk.addElement.createImageElement(item.full_preview_url)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "masonry",
      ref_key: "gridRef",
      ref: gridRef,
      style: _normalizeStyle({ '--cols': String(cols.value) })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resourceList.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: _normalizeClass(["masonry-item cursor-pointer", { 'span-2': isWide(item.id) }])
        }, [
          _createElementVNode("div", {
            class: "masonry-content",
            onClick: ($event: any) => (handleClick(item))
          }, [
            _createElementVNode("img", {
              src: item.full_preview_url,
              alt: "",
              class: "media",
              onLoad: ($event: any) => (onImgLoad($event, item))
            }, null, 40, _hoisted_3)
          ], 8, _hoisted_2)
        ], 2))
      }), 128))
    ], 4),
    (resourceList.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_unref(ElEmpty), { description: "暂无数据" })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})